export default async function fetchBotStatus(url, retries = 3, delay = 1000) {
  const makeRequest = async (attempt) => {
    try {
      const response = await fetch(`${import.meta.env.VITE_APP_API_URL}${url}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        // Add timeout to prevent hanging requests
        signal: AbortSignal.timeout(10000)
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error(`Error en la solicitud (intento ${attempt}):`, error);
      
      // If this is not the last attempt, retry after delay
      if (attempt < retries) {
        console.log(`Reintentando en ${delay}ms...`);
        await new Promise(resolve => setTimeout(resolve, delay));
        return makeRequest(attempt + 1);
      }
      
      // If all retries failed, return a default value
      console.warn('Todas las solicitudes fallaron, usando valor por defecto');
      return false; // Default to offline status
    }
  };
  
  return makeRequest(1);
}